export class Adjunto {
    //adjuntoId
    c1: string = "l66xHtlkmi56Uqz3MEYuqw==";
    //webpath
    c2: string = "";
    //nombre Original 
    c3: string = "";
    //??
    c4: string = "";
    //extension
    c5: string = ".pdf";
    //nombreNuevo
    c6: string = "";
    //??
    c7: string = "pdf.png";
    //idAsociado
    c8: string = "";
    //opcion (3 => Endoso)
    c9: string = "3";
    //modulo Flow de donde proviene
    c10: string = "94c3qaBTlOBbdUWPBkxEmg==";
    //filtroTipo (?)
    c11: string = "l66xHtlkmi56Uqz3MEYuqw==";
    //tipo de adjunto: caratula = 1
    c12: number = 1;
    //asegurado
    c13?: string = "";
    //apaga adjunto
    c14?: boolean = false;
}